import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { EditBannerComponent } from '../../alerts/banners/edit-banner/edit-banner.component';
import * as moment from 'moment';

@Component({
  selector: 'app-banner-grid',
  templateUrl: './banner-grid.component.html',
  styleUrls: ['./banner-grid.component.scss']
})
export class BannerGridComponent implements OnInit {
  @Input() activeArrData;
  @Input() inactiveArrData;
  @Input() mantenienceSection;
  @Output() editedData: EventEmitter<any> = new EventEmitter<any>();
  @Output() deletedData: EventEmitter<any> = new EventEmitter<any>();
  @Output() statusField: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private serviceModal: NgbModal,
  ) { }

  ngOnInit(): void { }

  delete(banner) {
    Swal.fire({
      title: `¿Desea eliminar <br> <b>${banner.title}</b>?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deletedData.emit(banner.id);
      }
    });
  }

  editBanner(banner) {
    const modal = this.serviceModal.open(EditBannerComponent, {
      centered: true,
      windowClass: 'custom-modal-banner d-flex flex-column w-100 justify-content-center h-85pr'
    });

    let listEmpyBanner = banner.bannerPromoImages.filter(x => x.img641Upload == false && x.img642Upload == false && x.urlBanner == '');
    listEmpyBanner.forEach(item => {
      var index = banner.bannerPromoImages.indexOf(item);
      if (index !== -1) {
        banner.bannerPromoImages.splice(index, 1);
      }
    });

    modal.componentInstance.bannerInfo = banner;
    modal.result.then((res) => {
      this.editedData.emit(res);
    }, (reason) => {

    });
  }

  changeStatus(banner: any, currentStatus: string) {
    Swal.fire({
      title: `${currentStatus === 'Desactivado' ? 'Habilitando' : 'Deshabilitando'} ${banner.title}...`,
      text: 'Por favor espere',
      icon: 'warning',
      backdrop: false,
    });
    Swal.showLoading();
    this.statusField.emit({
      id: banner.id
    });
  }

  getFormatDate(date: string) {
    return date ? moment(date).format("DD/MM/YYYY") : '';
  }
}
